import { IQueryConditionHandler } from './iquerycondition.handler';
import { QueryCondition, SmartHelpValue } from '@farris/component-querycondition';
import { CompareType } from '../enum/compare-type.enum';
import { ValueType } from '../enum/value-type.enum';
import { RelationType } from '../enum/relation-type.enum';

export class SmartHelpHandler implements IQueryConditionHandler {
  convert(qc: QueryCondition) {
    const shv = (qc.value as SmartHelpValue);
    if (shv.value.length == 0) return [];

    const arr = [];
    if (shv.isInputText || shv.valueField == null) {
      arr.push({
        'FilterField': qc.fieldCode,
        'Compare': (qc.compareType || qc.compareType === 0) ? qc.compareType : CompareType.Like,
        'Value': shv.textValue,
        'Relation': (qc.relation || qc.relation === 0) ? qc.relation : RelationType.And,
        'Expresstype': ValueType.Value
      });
      return arr;
    } else {
      shv.getOriginalValue().split(',').forEach((id) => {
        id && arr.push({
          'FilterField': qc.fieldCode,
          'Compare': (qc.compareType || qc.compareType === 0) ? qc.compareType : CompareType.Equal,
          'Value': id,
          'Relation': qc.compareType === CompareType.NotEqual ? RelationType.And : RelationType.Or,
          'Expresstype': ValueType.Value
        });
      });
      if (arr.length > 0) {
        arr[0]['Lbracket'] = qc.Lbracket ? (qc.Lbracket + '(') :'(';
        arr[arr.length -1]['Rbracket'] = qc.Rbracket ? (qc.Rbracket + ')') : ')';
        arr[arr.length - 1]['Relation'] = (qc.relation || qc.relation === 0) ? qc.relation : RelationType.And;
        return arr;
      } else {
        return [];
      }
    }
  }
}
